/*-----------------------------------
 * MP hayabusa Customize
 * [このファイルの役割]
 * ・プラグインの読み込み
 * ・URLによるモジュールの実行
 * ・サイト設定
 * ・URLによるCSS読み込み設定
 *-----------------------------------*/

import 'jquery.easing'
import './plugins/plugins'
import './plugins/utility'
import INIT from './modules/init'

// ページ読み込み
import HOME from './page/home'
import SHOP from './page/shop';
import ABOUT from './page/about';
import MAYAVINIC from './page/mayavinic';
import WHOLESALE from './page/wholesale';
import NEWS from './page/news';

/*****
 * サイト設定
 */
window.siteinfo = {
  tagmanager:       'GTM-5884H4F',
  
  viewport:         'width=device-width,initial-scale=1',
  mapApiKeys: {
    'local':          'AIzaSyCTB3MSMYkTjSz6l30k79XflmmL_FcOxkg', //development
    'www.hagukumuhito.jp': '' //production
  }
}

/*****
 * サイト初期化
 */
INIT()

/*****
 * コンテンツごとのファイル読み込み
 */
$.require({'*':['(js)//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit']})

switch(location.pathname.replace('main.php','')){
  // トップページ
  case '/': HOME(); break

  // お取引先紹介
  case '/shop/': SHOP(); break

  // 豆乃木について
  case '/about/': ABOUT(); break

  // 生産者パートナー
  case '/mayaviniccoffee/': MAYAVINIC(); break

  // 卸販売
  case '/wholesale/': WHOLESALE(); break

  // お知らせ
  case '/news/': NEWS(); break
}
